import Skeleton from "../ui/Skeleton";

const buttonSkeletonCSS = {
  position: "relative",
  display: "flex",
  width: "8rem",
  height: "2.75rem",
};

function ButtonSkeleton() {
  return (
    <>
      <Skeleton css={buttonSkeletonCSS} />
    </>
  );
}

export default ButtonSkeleton;
